module.exports = __webpack_public_path__ + "static/media/batiliskwing.5e996e9d.webp";